<template>
  <div v-if="users !== null">
    <v-row class="justify-space-between">
      <!-- 検索 -->
      <SearchInput
        v-model="search"
        style="max-width: 300px"
        :loading="searchLoading"
      />

      <v-btn
        v-if="is_admin"
        flat
        class="text-secondary"
        size="large"
        @click="$router.push({name: 'ManageAccounts'})"
      >
        {{ $t('Service.AssignUserLink', {menu: $t('Menu.ManageAccounts')}) }}
      </v-btn>
    </v-row>

    <v-data-table-server
      :items="users"
      :headers="headers"
      item-value="id"
      :items-per-page-options="[10, 25, 50, 100]"
      :items-length="pagination.totalItems"
      :items-per-page-text="$t('DataTable.RowsPerPage')"
      @update:options="syncPagination"
    >
      <template #item="{ item }">
        <tr>
          <td style="white-space: nowrap">
            <v-row class="align-center">
              <v-layout
                :reverse="reverse"
                row
                class="align-center"
              >
                <v-icon
                  v-if="item.is_active === false"
                  color="error"
                  class="mr-2"
                  icon="mdi-minus-circle"
                />
                <OpAvatar
                  class="mr-2"
                  :size="25"
                  :profile="item"
                />
                <div class="no-wrap">
                  {{ item.last_name }}
                </div>
                <div class="mr-1" />
                <div class="no-wrap">
                  {{ item.first_name }}
                </div>
              </v-layout>
            </v-row>
          </td>
          <td style="white-space: nowrap">
            {{ item.email }}
          </td>
          <td>
            <v-chip
              v-for="(v, index) in item.roles"
              :key="index"
              :class="{'text-primary: white': v==='admin'}"
              :color="v === 'admin' ? 'primary' : ''"
              variant="flat"
              density="compact"
            >
              {{ $t('User.Role.' + v) }}
            </v-chip>
          </td>
          <td>
            <v-chip
              v-for="(v, index) in item.user_group_names"
              :key="index"
              density="compact"
            >
              {{ v }}
            </v-chip>
          </td>
        </tr>
      </template>

      <template #no-data>
        <v-layout
          justify-center
          class="text-grey"
        >
          {{ $t('NoItems') }}
        </v-layout>
      </template>
    </v-data-table-server>
  </div>
  <div
    v-else
    class="pa-3"
  >
    ...
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import DrfSyncDataTableMixin from './mixins/DrfSyncDataTableMixin'
  import SearchInput from '@/components/parts/inputs/SearchInput'
  import OpAvatar from '@/components/parts/OpAvatar'

  export default {
    components: {
      OpAvatar,
      SearchInput
    },
    mixins: [DrfSyncDataTableMixin],
    props: {
      filterGroups: {
        type: Array,
        default () {
          return []
        }
      },
      filterServices: {
        type: Array,
        default () {
          return []
        }
      }
    },
    data: () => ({
      users: null,
      loadingList: false
    }),
    computed: {
      ...mapGetters(['ui', 'login']),
      reverse () {
        return this.$i18n.locale !== 'ja'
      },
      searchLoading () {
        return this.loadingList && this.search !== null
      },
      is_admin () {
        return Boolean(this.login.profile.is_admin)
      },
      headers () {
        return [
        { title: this.$t('User.UserName'), sortable: true, key: 'first_name_en' },
        { title: this.$t('User.EmailAddress'), sortable: true, key: 'email' },
        { title: this.$t('User.Role.Roles'), sortable: false },
        { title: this.$t('UserGroup.UserGroups'), sortable: false }
      ]
      }
    },
    watch: {
      'filterGroups' () { this.getListWatchDebounce() }
    },
    created () {
      this.getList()
    },
    methods: {
      getList () {
        this.loadingList = true
        let params = this.getSyncParams()
        params.user_groups = this.filterGroups
        params.services = this.filterServices
        this.$http('users/', { params: params }).then((res) => {
          this.users = res.data.results
          this.applySyncData(res)
          this.loadingList = false
        })
      }
    }
  }
</script>
